module.exports = __webpack_public_path__ + "img/descImg6.f7c52a97.png";